module.exports = __webpack_public_path__ + "static/Felis-D1-3613ffeb1218d2ef709ee0789d201fca.pdf";